import { render, staticRenderFns } from "./ListColsHeader.vue?vue&type=template&id=81a156f4&scoped=true&"
import script from "./ListColsHeader.vue?vue&type=script&lang=js&"
export * from "./ListColsHeader.vue?vue&type=script&lang=js&"
import style0 from "./ListColsHeader.vue?vue&type=style&index=0&id=81a156f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a156f4",
  null
  
)

export default component.exports